module.exports = __webpack_public_path__ + "img/pg_35.49557ace.png";